// extracted by mini-css-extract-plugin
export default {"container":"document_container__3xYC7","inner":"document_inner__3yLX7","isContainer":"document_isContainer__2neV7"};